import { render, staticRenderFns } from "./confirmChangeObjective.vue?vue&type=template&id=8dddc124&scoped=true&"
import script from "./confirmChangeObjective.vue?vue&type=script&lang=js&"
export * from "./confirmChangeObjective.vue?vue&type=script&lang=js&"
import style0 from "./confirmChangeObjective.vue?vue&type=style&index=0&id=8dddc124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dddc124",
  null
  
)

export default component.exports